import { Button, Stack } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";

type Props<T> = {
  items: T[];
  buttonText?: string;
  rowLength: number;
  renderItem: (item: T) => ReactNode;
};

export const ChipsList = <T,>({
  items,
  buttonText,
  rowLength,
  renderItem,
}: Props<T>) => {
  const [isExtended, setIsExtended] = useState<boolean>(false);

  useEffect(() => {
    if (items.length === 0) setIsExtended(false);
  }, [items]);

  if (items.length === 0) return null;

  const visibleItems = isExtended ? items : items.slice(0, rowLength);

  return (
    <Stack direction="row" gap="4px" alignItems="center" flexWrap="wrap">
      {visibleItems.map((el) => renderItem(el))}

      {items.length > rowLength && (
        <Button
          onClick={() => setIsExtended(!isExtended)}
          variant="text"
          sx={{
            color: "#4C545B",
            textWrap: "nowrap",
            backgroundColor: "transparent",
            marginLeft: "16px",
            "&:hover": {
              color: "#82848d",
            },
          }}
        >
          {isExtended ? "Hide" : buttonText || "View all"}
        </Button>
      )}
    </Stack>
  );
};
